// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const CloudFormationIcon = createSvgIcon(
  <svg fill="currentColor" viewBox="0 0 2500 2500">
    <path
      fill="#B7CA9D"
      d="m410.1 1698.3 16.4 18.6 827.9 234.7 3.8-145.5-579.8-145.5-28.4-10.2z"
    />
    <path
      fill="#B7CA9D"
      d="m2089.9 1698.3-845.5 282.2-2.5-174.4 579.8-145.5 25.3-28.4z"
    />
    <path
      fill="#3C4929"
      d="m1241.8 701.3 579.8 135.1 255-12.1 13.2-25.6L1282 508z"
    />
    <path
      fill="#759C3E"
      d="m678.3 1660.6-268.2 37.7-7.5-27.8V828.1l7.5-29.3 242.3 18 25.9 19.7z"
    />
    <path
      fill="#3C4929"
      d="M1258.1 701.3 678.3 836.5l-268.2-37.7 10.1-15.9 834.2-237.4z"
    />
    <path
      fill="#4B612C"
      d="M1248.8 74.9 285.9 561l.5 1375.4 962.5 485.8 14.3-21.8V103.2zM967.3 1865.5l-557.1-167.2V798.8l557.1-167.2zm854.3-204.9 268.2 37.7 15-26.6V824.4l-15-25.6-268.2 37.7z"
    />
    <path
      fill="#759C3E"
      d="m1248.8 2422.2 964.8-485.8.5-1375.4-965.3-486.1zm283.9-1790.6 557.2 167.2v899.5l-557.2 167.2z"
    />
  </svg>,
  "CloudFormation",
);
export default CloudFormationIcon;
